import type { Middleware, Dispatch, AnyAction } from '@reduxjs/toolkit';

import { InternalAxiosRequestConfig } from 'axios';
import { toast } from 'react-toastify';

import apiClient from '../api/axios.config';
import { RootState } from '../reducers';
import { refreshToken } from '../redux/auth/auth.actions';
import { RouteRulePath } from '../routes/RouteManager';
import { goTo } from './navigation';

interface customAxiosRequest<D = any> extends InternalAxiosRequestConfig<any> {
	unauthorized?: boolean; // Voliteľná vlastnosť `unauthorized`
}

const apiMiddleware: Middleware<object, RootState, Dispatch<AnyAction>> =
	(store) =>
	(next: any) =>
	(action: any): any => {
		if (!action) {
			return next(action); // TODO: overit co to vlasnte robi a ci sa to niekedy vykona
		}
		const dispatch = store.dispatch;
		const auth = (store.getState() as RootState).auth;
		const accessToken = auth.user?.accessToken || '';
		const exp = auth.user?.expAccessToken || 0;

		apiClient.interceptors.request.use(
			// TODO: je nutne volat pred kazdym requestom aby som overil token
			async (config: customAxiosRequest) => {
				const verifyToken = (authorization: string | null) => {
					if (authorization) {
						config.headers.Authorization = authorization;
					} else {
						delete apiClient.defaults.headers.common['Authorization'];
					}

					return config;
				};
				if (!config.unauthorized || !config.headers.unauthorized) {
					//TODO: opravit vsade header unauthorized
					if (accessToken && exp > Date.now() / 1000 - 5) {
						const authorization = `Bearer ${accessToken}`;
						return verifyToken(authorization);
					} else {
						const rToken = auth.user?.refreshToken;
						if (rToken) {
							toast.info('refresh token', {
								toastId: 'refresh-success',
							});
							await refreshToken(rToken, dispatch, () => {
								const auth = (store.getState() as RootState).auth;
								const accessToken = auth.user?.accessToken || null;
								const authorization = (accessToken && `Bearer ${accessToken}`) || null;
								verifyToken(authorization);
							});
						}
					}
				} else {
					toast.error('go home middleware', {
						toastId: 'error-success',
					});
					goTo(RouteRulePath.home);
					return verifyToken(null);
				}

				return config;
			},
			(error) => {
				toast.error('error token', {
					toastId: 'error-success',
				});
				return Promise.reject(error);
			}
		);

		return next(action);
	};

export default apiMiddleware;
